import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type FlowLineProps = {
  steps: string[];
  label?: string;
  className?: string;
  tone?: 'light' | 'dark';
};
export function FlowLine({
  steps,
  label,
  className = '',
  tone = 'light'
}: FlowLineProps) {
  const dark = tone === 'dark';
  return <div className={className} data-id="element-117" data-mp="3vx2g91gu05fc">
      {label && <p className={`mb-3 text-xs font-bold uppercase tracking-[0.14em] ${dark ? 'text-champagne' : 'text-burgundy'}`} data-id="element-118" data-mp="3vzovln9yrp84">
          {label}
        </p>}
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-2" aria-label={steps.join(', ')} data-id="element-119" data-mp="33ahmxvgspj95">
        {steps.map((step, index) => <li key={step} className="flex items-center gap-2" data-id="element-120" data-mp="3c93euh85qaml" data-mpi={index}>
            <span className={`rounded-md border px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.08em] ${dark ? 'border-gold/40 bg-white/5 text-champagne' : 'border-gold/40 bg-beige/60 text-ink'}`} data-id="element-121" data-mp="3cbplmen84m3r">
              {step}
            </span>
            {index < steps.length - 1 && <ArrowRightIcon size={14} className="shrink-0 text-gold" aria-hidden="true" data-id="element-122" data-mp="1omrs6r1gr7ex" />}
          </li>)}
      </ol>
    </div>;
}